var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isPhone)?_c('my-header'):_vm._e(),_c('router-view'),_c('wechat-nav'),_c('pay-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }